import React, { useEffect, useRef, useState } from "react";
import {
  IonModal,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
} from "@ionic/react";
import closeIcon from "../../assets/imgs/close.svg";
import { useSupabaseAuth } from "../../Context/AuthContext/AuthContext";
import useFirebaseAnalytics from "../../hooks/useFirabaseAnality";
import { useMixpanel } from "../../../src/Context/MixpanelContext/MixpanelProvider";
import { isMobile } from "react-device-detect";
import DeleteAccountModal from "../UserProfile/DeleteAccountModal";
import { Button } from "../ui/button";
import { Colors } from "../Commons/Colors/Colors";
import { Paragraph } from "../Commons/Paragraph";
import profileIcon from "../../assets/imgs/account-profile.png";
import arrowProfile from "../../assets/imgs/arrow_profile_right.svg";
import deleteAccount from "../../assets/imgs/delete_account.svg";
import { useSelector } from "react-redux";
import { actions } from "../../../src/Redux/store";
import { Capacitor } from "@capacitor/core";
import { pulsar } from "ldrs";
import { hapticsImpactLight } from "../../lib/utils";
pulsar.register();
interface profile {
  id?: string | undefined | null;
  user_email?: string | undefined | null;
  phone?: string | undefined | null;
  user_dob?: string | undefined | null;
  user_name?: string | undefined | null;
  avatar_url?: string | undefined | null;
}

export default function AccountModal() {
  const {
    signout,
    uploadAvatar,
    getUserProfile,
    getUserData,
    deactivateAccount,
    uploading,
  } = useSupabaseAuth();
  const [phone, setPhone] = useState<string | undefined | null>();
  const [email, setEmail] = useState<string | undefined | null>();
  const [name, setName] = useState<string | undefined | null>();
  const [birthday, setBirthDay] = useState<string | undefined | null>();
  const [userId, setUserId] = useState<string | undefined>();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [profile, setProfile] = useState<any>(null);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [avatar, setAvatar] = useState<string | undefined | null>(null);
  const [delAccountModal, setDelAccountModal] = useState(false);
  const { logEventAnalytics } = useFirebaseAnalytics();
  const Mixpanel = useMixpanel();
  const modal = useRef<HTMLIonModalElement>(null);
  const isOpen = useSelector((sate: any) => sate.modal.accountModal?.open);
  const toggle = () => {
    actions.modal.closeAccountModal(null);
  };
 const platform = Capacitor.getPlatform();
  function dismiss() {
    modal.current?.dismiss();
    toggle();
  }

  const handleClose = () => {
    modal.current?.dismiss();
  };

  async function signOutHandler() {
    try {
      await signout();
      window.location.replace("/welcome");
    } catch (error) {
      console.log("error on sign out", error);
    }
  }

  const handlerDeactivateAccount = async () => {
    try {
      await deactivateAccount(userId as string);
      window.location.replace("/welcome");
      logEventAnalytics("user_deleted_account", { name: "Delete Account" });
      Mixpanel.trackEvent("user_deleted_account", { name: "Delete Account" });
    } catch (error) {
      console.log("error on Delete Account", error);
    }
  };

  const fetchCurrentUser = async () => {
    const response = await getUserData();

    if (response) {
      setCurrentUser(response?.data?.user);
      setUserId(response?.data?.user?.id);
    }
  };

  // Only fetch user data when the modal is opened
  useEffect(() => {
    if (isOpen) {

      fetchCurrentUser();
    }
  }, [isOpen]);

  const fetchProfile = async () => {
    if (
      currentUser &&
      (currentUser?.app_metadata?.provider === "phone" ||
        currentUser?.app_metadata?.provider === "apple")
    ) {
      const userProfile: profile | null | undefined = await getUserProfile(
        currentUser?.id,
      );

      setEmail(userProfile?.user_email);
      setName(userProfile?.user_name);
      setBirthDay(userProfile?.user_dob);
      setProfile(userProfile);
      setPhone(currentUser?.phone);
      // Set avatar from profile data for phone/Apple users
      setAvatar(userProfile?.avatar_url);
    } else {
      const identity_data = currentUser?.identities?.[0]?.identity_data ?? null;
      setEmail(identity_data?.email);
      setName(identity_data?.full_name);
      setPhone(currentUser?.phone);

      // For Google users, first check if they have a custom avatar in profile, otherwise use Google avatar
      const userProfile: profile | null | undefined = await getUserProfile(
        currentUser?.id,
      );
      setAvatar(userProfile?.avatar_url || identity_data?.avatar_url);
    }
  };
  console.log("currentUser **", currentUser);

  useEffect(() => {
    fetchProfile();
  }, [currentUser]);

  const handleFileChange = async (event: any) => {
    hapticsImpactLight();
    fileInputRef.current?.click();
    if (event.target.files) {
      const file = event.target.files[0];
      if (file && userId) {
        try {
          const img = await uploadAvatar(file, userId);
          if (img) {
            setAvatar(img); // Update the avatar immediately with the new URL
          }
          fetchProfile();
        } catch (error) {
          console.error("Error uploading avatar:", error);
        }
      }
    }
  };
  return (
    <IonModal
      onDidDismiss={dismiss}
      className={`full-modal`}
      isOpen={isOpen}
      backdropDismiss={false}
      ref={modal}
    >
      <>
        <IonHeader class="ion-no-border modal-ion-header">
          <IonToolbar
            className="mt-[15px]"
            style={{
              "--background": "none",
            }}
          >
            <div className=" flex justify-between items-center sticky top-0 z-50 md:mx-2">
              <div onClick={handleClose} className="cursor-pointer p-2">
                <img
                  src={closeIcon}
                  alt="close"
                  className="w-[15px] h-[15px] "
                />
              </div>

              <IonTitle className="text-[20px] md:text-[22px] font-medium text-white">
                {"Account"}
              </IonTitle>
            </div>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className="p-4">
            <div className="flex flex-col items-center">
              <div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  className="hidden"
                />
              </div>
              <button
                className="w-[85px] h-[85px] flex justify-center items-center mb-3 relative"
                onClick={handleFileChange}
                disabled={uploading}
                style={{ borderColor: Colors.backgroundPrimary }}
              >
                {uploading ? (
                  <l-pulsar size="85" speed="1.75" color="white"></l-pulsar>
                ) : avatar ? (
                  <img
                    src={avatar}
                    alt="Profile"
                    className={"w-full h-full rounded-full object-cover border-4 border-[#3EC4FF]"}
                  />
                ) : (
                  <img
                    src={profileIcon}
                    alt="Profile"
                    className={"w-full h-full rounded-full object-cover"}
                  />
                )}
              </button>
              <div   onClick={handleFileChange}>
                <span className="text-[15px] font-semibold text-white">
                  Change Avatar
                </span>
              </div>
            </div>
            <div className="mt-7">
              <div className="flex justify-between border-t border-white/10 py-[15px]">
                <span className="text-[13px] text-white font-medium pl-[5px]">
                  Name
                </span>

                <div className="flex items-center gap-2 pr-[5px]">
                  <span className="text-[13px] text-white/70 font-medium ">
                    {name ? name : "****Mastroianni"}
                  </span>
                </div>
              </div>
              {email && (
                <div className="flex justify-between border-t border-white/10 py-[15px]">
                  <span className="text-[13px] text-white font-medium pl-[5px]">
                    Email
                  </span>
                  <div className="flex items-center gap-2 pr-[5px]">
                    <span className="text-[13px] text-white/70 font-medium ">
                      {email}
                    </span>
                  </div>
                </div>
              )}
              {phone && (
                <div className="flex justify-between border-t border-white/10 py-[15px]">
                  <span className="text-[13px] text-white font-medium pl-[5px]">
                    Phone Number
                  </span>
                  <div className="flex items-center gap-2 pr-[5px]">
                    <span className="text-[13px] text-white/70 font-medium pr-[5px]">
                      {phone}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="flex flex-col items-center mt-2">
              <Button
                variant="destructive"
                size="default"
                onClick={signOutHandler}
                className="bg-transparent hover:bg-transparent text-[13px] font-semibold"
              >
                {" "}
                Log Out{" "}
              </Button>
            </div>
            <DeleteAccountModal
              isVisible={delAccountModal}
              onClose={() => setDelAccountModal(false)}
              handleDel={handlerDeactivateAccount}
            />
          </div>
        </IonContent>

        <div
          className="sticky bottom-0 z-50 border-t border-white/10 mx-[20px] cursor-pointer"
          onClick={() => setDelAccountModal(true)}
          style={{
            paddingTop: "16px",
            paddingBottom: "calc(env(safe-area-inset-bottom) + 10px)",
          }}
        >
          <div className="flex-col">
            <div className="flex gap-2 items-center">
              <img src={deleteAccount} alt="deleteAccount" />
              <span className="text-[#FF0000] text-[12px] font-medium">
                Delete account
              </span>
            </div>
            <span className="text-[10px] font-medium text-white/70 mt-3">
              Use to delete your account permanently
            </span>
          </div>
        </div>
      </>
    </IonModal>
  );
}
